import { render } from "./author-identity.vue?vue&type=template&id=54cb97fc&scoped=true"
import script from "./author-identity.vue?vue&type=script&lang=js"
export * from "./author-identity.vue?vue&type=script&lang=js"

import "./author-identity.vue?vue&type=style&index=0&id=54cb97fc&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cb97fc"]])

export default __exports__